import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { BarChart3, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Email required");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Request failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6" style={{ fontFamily: "Manrope" }}>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-8 h-8 bg-blue-600 rounded text-white flex items-center justify-center">
            <BarChart3 className="w-4 h-4" />
          </div>
          <div className="font-semibold text-slate-900">RSOC × Hub</div>
        </div>

        <h1 className="text-2xl font-semibold mb-2">Forgot password?</h1>
        <p className="text-sm text-slate-500 mb-6">Enter the email on your account and we'll send you a reset link.</p>

        {sent ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-md p-4" data-testid="forgot-sent-banner">
            <div className="text-sm font-medium text-emerald-900">Check your inbox</div>
            <div className="text-xs text-emerald-700 mt-1">
              If that email is registered, a reset link is on its way (it'll expire in 1 hour and can only be used once).
            </div>
            <Link to="/login" data-testid="back-to-login" className="mt-4 inline-flex items-center gap-1.5 text-xs text-slate-900 hover:underline">
              <ArrowLeft className="w-3 h-3" /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="forgot-password-form">
            <input
              type="email"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@yourcompany.com"
              data-testid="forgot-email-input"
              className="w-full bg-white border border-slate-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="forgot-submit-btn"
              className="w-full bg-blue-600 text-white rounded-md px-3 py-2 text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-60"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-900 mt-3">
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
